import required from '../../src/assets/img/icon/required.png';

function StarRequired() {
  return (
    <span><img src={required} width="10px" alt='icon'/></span>
  )
}

export default StarRequired